import { useState } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import PhoneAuthPanel from './PhoneAuthPanel';

type Tab = 'password' | 'phone' | 'register';

const TABS: { key: Tab; label: string }[] = [
  { key: 'password', label: 'Password' },
  { key: 'phone', label: 'Phone OTP' },
  { key: 'register', label: 'Register' },
];

export default function LoginPanel() {
  const [tab, setTab] = useState<Tab>('password');
  return (
    <div>
      <div className="flex gap-1 bg-gray-100 rounded-lg p-1 mb-5 text-sm">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex-1 px-3 py-1.5 rounded-md transition ${
              tab === t.key ? 'bg-white shadow text-violet-700 font-medium' : 'text-gray-600'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'password' && (
        <Authenticator hideSignUp components={{ Header() { return null; } }} />
      )}
      {tab === 'phone' && <PhoneAuthPanel mode="login" />}
      {tab === 'register' && <PhoneAuthPanel mode="register" />}
    </div>
  );
}
